import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdmin } from '../auth/AdminContext';
import { updateVisibility } from '../services/api';

const AdminPanel = ({ titles, visibilities, setVisibilities }) => {
  const { isAdmin, login, logout, token } = useAdmin();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    const ok = await login(username, password);
    if (ok) {
      setError('');
      navigate('/');
    } else {
      setError('Väärä käyttäjä tai salasana');
    }
  };

  const handleVisibilityChange = async (key, isVisible) => {
    try {
      await updateVisibility(key, isVisible, token);
      setVisibilities(prev => ({ ...prev, [key]: isVisible }));
    } catch (e) {
      // Virheenkäsittely
    }
  };

  if (isAdmin) {
    return (
      <div>
        <h1>Admin-paneeli</h1>
        <p>Olet kirjautunut adminiksi.</p>
        <button onClick={logout}>Kirjaudu ulos</button>

        <h2>Sivujen näkyvyys</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {Object.keys(titles).map(key => (
            <div key={key}>
              <label>
                <input
                  type="checkbox"
                  checked={visibilities[key] !== false}
                  onChange={(e) => handleVisibilityChange(key, e.target.checked)}
                />
                {titles[key]}
              </label>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div>
      <h1>Admin-kirjautuminen</h1>
      <form onSubmit={handleLogin}>
        <input
          type="text"
          placeholder="Käyttäjätunnus"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          placeholder="Salasana"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit">Kirjaudu</button>
      </form>
      {error && <p style={{ color: 'tomato' }}>{error}</p>}
    </div>
  );
};

export default AdminPanel;